import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c972af8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c972af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c972af8')) {
      api.createRecord('6c972af8', component.options)
    } else {
      api.reload('6c972af8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c972af8&scoped=true", function () {
      api.rerender('6c972af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeHealth/index.vue"
export default component.exports